import productConverter from "./productConverter";

const productStockAlertConverter = {
    convertIn: (responseData) => {
        if (responseData.product) {
            responseData.product = productConverter.convertIn(responseData.product);
        }

        return responseData;
    },
};

export default productStockAlertConverter;
